import { cn } from '@/lib/utils';

interface TagBadgeProps {
  name: string;
  color: string;
  selected?: boolean;
  onClick?: () => void;
  className?: string;
}

export function TagBadge({ name, color, selected, onClick, className }: TagBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        onClick && 'cursor-pointer',
        className,
      )}
      style={
        selected
          ? { backgroundColor: color, color: '#fff', border: `1px solid ${color}` }
          : {
              backgroundColor: `${color}20`,
              color,
              border: `1px solid ${color}40`,
            }
      }
      onClick={onClick}
    >
      {name}
    </span>
  );
}
